import React, { useEffect } from "react";
import Dermatologycon from "./Dermatologycon";
import Infiry from "../../About/Infiry";
import Callin from "../../About/Callin";
import Servicebanner from "../../Services/Servicebanner";
import NumberInfo from "../../Home/NumberInfo";
import Doctorbox from "../../Home/Docterbox";
import Divser from "../../About/Divser";
import Divider from "../../Divider";
import ServiceReview from "../../Services/ServiceReview";
import { movetop } from "../../../fun";
import { Helmet } from "react-helmet-async";

function Dermatology() {
  type elem = {
    oneBody?: JSX.Element;
    twoBody?: JSX.Element;
    threeBody?: JSX.Element;
  };
  const elemnt: elem = {
    oneBody: <Dermatologycon />,
    twoBody: <Infiry />,
    threeBody: <Callin />,
  };

  useEffect(() => {
    movetop();
  }, []);
  return (
    <>
      <Helmet>
        <title>Best Dermatology Clinic in Vijayanagar</title>
        <meta
          name="description"
          content="Looking for the best dermatology clinic in Vijayanagar? Then you are at the right place. Feel free to contact us today."
        />
        <meta
          name="keywords"
          content="Best Dermatology clinic in Whitefield, Best Dermatology clinic in Vijayanagar, healthcare services in Whitefield, healthcare services in Vijayanagar, Multispeciality Clinic in Vijayanagar"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "@id":
              "https://www.elvhealthcare.com/bestdermatologyservicesinwhitefield#organization",
            name: "ELV Health Care Polyclinics",
            url: "https://www.elvhealthcare.com/bestdermatologyservicesinwhitefield",
            description:
              "ELV Health Care Polyclinics in Whitefield provides expert dermatology services including diagnosis and treatment of skin, hair, and nail conditions, acne care, pigmentation treatment, eczema and psoriasis management, and cosmetic skin procedures with experienced dermatologists.",
            logo: "https://www.elvhealthcare.com/favicon.ico",
            telephone: "+91-9535264855",
            email: "elvhealthcare@gmail.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "MR ASTER, Ground Floor, Vijayanagar, Whitefield",
              addressLocality: "Bengaluru",
              addressRegion: "Karnataka",
              postalCode: "560066",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: 12.9764418,
              longitude: 77.7583566,
            },
            hasMap: "https://maps.app.goo.gl/C1xXW4kQyTxR8Sug9",
            knowsAbout: [
              "Medical dermatology services",
              "Acne and scar treatment",
              "Pigmentation & skin brightening",
              "Eczema and psoriasis care",
              "Hair loss treatment",
              "Anti-aging cosmetic dermatology",
              "Laser skin treatments",
            ],
            keywords: [
              "best dermatology services in Immadihalli",
              "best dermatology services in Whitefield",
              "best dermatology services in Bangalore",
              "best dermatology services in Kundalahalli",
              "best dermatology services in Pattandur Agrahara",
            ],
          })}
        </script>
      </Helmet>

      <h2 style={{ display: "none" }}>
        Dermatology clinic in Vijayanagar compassionate service sets us apart as
        a leader in Dermatology services. We are the best dermatology clinic in
        Vijayanagar. Contact us now.
      </h2>

      <Servicebanner name="Dermatology" banner={"../photo/dd5.jpg"} />
      <NumberInfo test="test-black" />
      <Doctorbox />
      <Divser elemnt={elemnt} />
      {/* <div className="pt-6">
            <Divider />
          </div>
          <Doctorbox /> */}
      <div className="pt-10 pb-4">
        <Divider />
      </div>
      <ServiceReview />
    </>
  );
}

export default Dermatology;
